import React from "react";

const Playbook = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* LEFT SIDE TEXT */}
        <div style={styles.left}>
          <h1 style={styles.heading}>Sales Playbook</h1>

          <p style={styles.text}>
            This sales playbook is designed to help you understand proven
            strategies, frameworks, and best practices used by
            top-performing sales teams.
          </p>

          <p style={styles.text}>
            Inside, you’ll find actionable insights, practical techniques,
            and step-by-step guidance to help you close more deals and grow
            your revenue with confidence.
          </p>

          {/* Download Button */}
          <a
            href="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/docs/Sales%20Playbook%20By%20Reflex.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <button style={styles.button}>
              Download Playbook for Free
            </button>
          </a>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <div style={styles.right}>
          <img
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/playbook.png"
            alt="Sales Playbook"
            style={styles.image}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    padding: "60px 20px",
    backgroundColor: "#000000",
    fontFamily: "Elza, sans-serif",
  },

  content: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    gap: "60px",
    width: "100%",
  },

  left: {
    flex: 1,
    textAlign: "left",
    marginLeft: "40px",
  },

  right: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
  },

  heading: {
    fontSize: "56px",
    fontWeight: "600",
    marginBottom: "28px",
    color: "#ffffff",
    lineHeight: "1.2",
  },

  text: {
    fontSize: "18px",
    lineHeight: "1.7",
    color: "#e5e7eb",
    marginBottom: "20px",
    maxWidth: "520px",
  },

  button: {
    marginTop: "20px",
    backgroundColor: "#7b19bc",
    color: "#ffffff",
    border: "none",
    padding: "16px 34px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "10px",
    cursor: "pointer",
    fontFamily: "Elza, sans-serif",
  },

  image: {
    maxWidth: "100%",
    height: "auto",
    borderRadius: "16px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
  },
};

export default Playbook;
